import { Helmet } from 'react-helmet';
import AppPaths from '../../AppPaths';
import { useLocale } from '../../contexts/LocaleContext';
import buildShopProductsJsonLd, { ShopProductForJsonLd } from '../../lib/shopProductsJsonLd';
import * as types from '../../types';

interface ShopProductsJsonLdProps {
  products: ShopProductForJsonLd[];
  discountsByKey: Record<string, types.HardwareDiscountPreview | undefined>;
}

/** Product JSON-LD for the pick-your-fi shop; see `buildShopProductsJsonLd` for what it publishes and why. */
export default function ShopProductsJsonLd({ products, discountsByKey }: ShopProductsJsonLdProps) {
  const { currency, country } = useLocale();
  if (typeof window === 'undefined') {
    return null;
  }
  // Anything after `/shop` (a trailing slash, a sub-path legacy's prefix route still matches) is not
  // the shop's URL; anything before it is main's language tree (`/de/shop`).
  const shopPath = window.location.pathname.replace(/\/shop(\/.*)?$/i, AppPaths.Shop);
  const jsonLd = buildShopProductsJsonLd(products, discountsByKey, currency, country, window.location.origin, shopPath);
  if (!jsonLd) {
    return null;
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
